import React, { useEffect, useState } from 'react';
import { Link,useParams } from 'react-router-dom';
import { getData } from '../Services/api';
import Pagination from '../Services/Pagination';

const CallLog = () => {
  const [calls, setCalls] = useState([]);
  const [page, setPage] = useState(1);
  const [pages, setPages] = useState(1);
  const [total, setTotal] = useState(0);
  const [search, setSearch] = useState('');
  const { id } = useParams();

  const fetchCalls = async (pageNumber = page, searchQuery = search) => {
    try {
      const res = await getData(
        `/calls/call-log-get-using-id?page=${pageNumber}&search=${searchQuery}&userId=${id}`
      );
      if (res.success) {
        setCalls(res.calls || []);
        setPage(res.currentPage || 1);
        setPages(res.totalPages || 0);
        setTotal(res.totalRecords || 0);
      }
    } catch (error) {
      console.log('Error fetching calls:', error);
    }
  };

  useEffect(() => {
    fetchCalls();
  }, [page, search]);

  const handlePageChange = (pageNumber) => {
    if (pageNumber !== page) {
      fetchCalls(pageNumber);
    }
  };

  return (
    <>
      <div className="pc-container">
        <div className="pc-content">
          <div className="page-header">
            <div className="page-block">
              <div className="row align-items-center">
                <div className="col-md-12">
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/">Home</Link>
                    </li>
                    <li className="breadcrumb-item" aria-current="page">
                      Call Log
                    </li>
                  </ul>
                </div>
                <div className="col-md-12">
                  <div className="page-header-title">
                    <h2 className="mb-0">Call Log</h2>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Table */}
          <div className="row">
            <div className="col-sm-12">
              <div className="card table-card">
                <div className="card-body">
                  <div className="d-sm-flex align-items-center p-4">
                    <ul className="list-inline me-auto my-1">
                      <li className="list-inline-item">
                        <div className="form-search">
                          <i className="fas fa-search" />
                          <input
                            type="search"
                            className="form-control"
                            placeholder="Search calls"
                            value={search}
                            onChange={(e) => {
                              setSearch(e.target.value);
                              setPage(1);
                            }}
                          />
                        </div>
                      </li>
                    </ul>
                  </div>

                  <div className="table-responsive">
                    <table className="table table-hover" id="pc-dt-simple">
                      <thead>
                        <tr>
                        <th>S.No.</th>
                        <th>Name</th> {/* Display customer or user name */}
                        <th>Call To</th>
                        <th>Connect Status</th>
                        <th>Duration (sec)</th>
                        <th>Called At</th>
                        </tr>
                      </thead>
                      <tbody>
                        {calls?.length > 0 ? (
                            calls.map((call, index) => (
                            <tr key={call.id}>
                                <td>{index + 1 + (page - 1) * 10}</td>
                                <td>{call.displayName || 'Unknown'}</td>
                                <td>{call.call_to}</td>
                                <td>{call.connectStatus}</td>
                                <td>{call.durationSeconds}</td>
                                <td>{new Date(call.calledAt).toLocaleString()}</td>
                            </tr>
                            ))
                        ) : (
                            <tr>
                            <td className="text-center" colSpan={6}>
                                <strong>No Calls Found.</strong>
                            </td>
                            </tr>
                        )}
                        </tbody>
                    </table>
                  </div>

                  {/* Pagination */}
                  <div className="d-flex justify-content-between align-items-center px-4 pb-3">
                    <div className="text-muted">
                      Showing {(page - 1) * 10 + 1} to{' '}
                      {Math.min(page * 10, total)} of {total} entries
                    </div>
                    <Pagination
                      page={page}
                      pages={pages}
                      onPageChange={handlePageChange}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CallLog;
